<soft-page>
  <soft-page-header>
    <div class="flex flex-row items-center px-6 min-w-[12rem]">
      <soft-icon name="fa-regular fa-calendar-lines fa-xl" class="mr-4"></soft-icon>
      <div class="flex flex-col items-start text-left">
        <div class="text-sm font-semibold">{{ 'Zeitraum' | translate }}</div>
        <div class="soft-link text-sm" (click)="editZeitraum()">{{ $safeNavigationMigration(query()?.vondatum) | format:'DATE.DEFAULT' }} - {{ $safeNavigationMigration(query()?.bisdatum) | format:'DATE.DEFAULT' }}</div>
      </div>
    </div>
  </soft-page-header>

  <div class="soft-card mt-4 flex flex-col">
    <h6 class="soft-overline">Bezeichnung</h6>
    <ul class="flex flex-col w-full border">
      <li class="flex w-full py-2 gap-3 items-center px-2 cursor-pointer !border-b">
        <div class="w-3/12">&nbsp;</div>
        <div class="grid grid-cols-6 w-9/12">
          <div class="text-right self-end justify-self-end font-semibold">
            KG
          </div>
          <div class="text-right self-end justify-self-end font-semibold">
            Liter
          </div>
          <div class="text-right self-end justify-self-end font-semibold">
            FE
          </div>
          <div class="text-right self-end justify-self-end font-semibold">
            FE %
          </div>
          <div class="text-right self-end justify-self-end font-semibold">
            EE
          </div>
          <div class="text-right self-end justify-self-end font-semibold">
            EE %
          </div>
        </div>
      </li>
      @for (symbol of lagersymbole(); track symbol.symbol.bezeichnung; let first = $first; let last = $last;) {
      <li class="flex w-full py-2 gap-3 items-center px-2 cursor-pointer"
          [class.border-t]="!first"
          (click)="selectedRow.set(symbol)"
          [ngClass]="[
            selectedRow()?.symbol?.bezeichnung === symbol.symbol.bezeichnung ? 'bg-surface border-l-4 border-l-primary' : 'bg-surface-tertiary border-l-0',
            last ? 'border-t-solid border-t border-t-gray-400' : ''
          ]">
        <div class="w-3/12">
          {{ symbol.symbol.bezeichnung }}
        </div>
        <div class="grid grid-cols-6 w-9/12">
          <div class="text-right self-end justify-self-end">
            {{ symbol.werte.kg | number: '1.2-2' }}
          </div>
          <div class="text-right self-end justify-self-end">
            {{ symbol.werte.liter | number: '1.2-2' }}
          </div>
          <div class="text-right self-end justify-self-end">
            {{ symbol.werte.fetteinheiten | number: '1.2-2' }}
          </div>
          <div class="text-right self-end justify-self-end">
            {{ symbol.werte.fetteinheitenProz | number: '1.2-2' }}
          </div>
          <div class="text-right self-end justify-self-end">
            {{ symbol.werte.eiweisseinheiten | number: '1.2-2' }}
          </div>
          <div class="text-right self-end justify-self-end">
            {{ symbol.werte.eiweisseinheitenProz | number: '1.2-2' }}
          </div>
        </div>
      </li>
      }
    </ul>
  </div>

  @if (loadingDetails()) {
    <div class="grid grid-cols-4 gap-4 mt-4 h-24 w-full">
      <div class="h-24 w-full soft-skeleton skeleton"></div>
      <div class="h-24 w-full soft-skeleton skeleton"></div>
      <div class="h-24 w-full soft-skeleton skeleton"></div>
      <div class="h-24 w-full soft-skeleton skeleton"></div>
    </div>
  } @else if (details() && (details()?.length ?? 0) > 0) {
    <div class="overflow-x-auto overflow-y-auto mt-4 max-h-[50vh] ">
      <table class="soft-table-2 w-full overflow-y-auto overflow-x-auto">
        <thead>
        <tr>
          <th class="min-w-[16rem]"></th>
          <th class="min-w-[16rem]"></th>
          <th colspan="6" class="md:border-r">Ist</th>
          <th colspan="6" class="md:border-r">Soll</th>
          <th colspan="6" class="md:border-r">Differenz</th>
        </tr>
        <tr>
          <th class="md:border-r min-w-[16rem] text-left" softSortHeader="artikel.bezeichnung" [sort]="sort()" (sortChange)="sortChanged($event)">Bezeichnung</th>
          <th class="md:border-r min-w-[16rem] text-left" softSortHeader="hfArtikel.bezeichnung" [sort]="sort()" (sortChange)="sortChanged($event)">Prod-Artikel</th>
          <!-- -->
          <th class="!text-right min-w-[5rem]" softSortHeader="ist.kg" [sort]="sort()" (sortChange)="sortChanged($event)">KG</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="ist.liter" [sort]="sort()" (sortChange)="sortChanged($event)">Liter</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="ist.fetteinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">FE</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="ist.fetteineheitenProz" [sort]="sort()" (sortChange)="sortChanged($event)">FE %</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="ist.eiweisseinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">EE</th>
          <th class="md:border-r !text-right min-w-[5rem]" softSortHeader="ist.eiweisseinheitenProz" [sort]="sort()" (sortChange)="sortChanged($event)">EE %</th>
          <!-- -->
          <th class="!text-right min-w-[5rem]" softSortHeader="soll.kg" [sort]="sort()" (sortChange)="sortChanged($event)">KG</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="soll.liter" [sort]="sort()" (sortChange)="sortChanged($event)">Liter</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="soll.fetteinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">FE</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="soll.fetteineheitenProz" [sort]="sort()" (sortChange)="sortChanged($event)">FE %</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="soll.eiweisseinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">EE</th>
          <th class="md:border-r !text-right min-w-[5rem]" softSortHeader="soll.eiweisseinheitenProz" [sort]="sort()" (sortChange)="sortChanged($event)">EE %</th>
          <!-- -->
          <th class="!text-right min-w-[5rem]" softSortHeader="diff.kg" [sort]="sort()" (sortChange)="sortChanged($event)">KG</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="diff.eiweisseinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">Liter</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="diff.fetteinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">FE</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="diff.fetteineheitenProz" [sort]="sort()" (sortChange)="sortChanged($event)">FE %</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="diff.eiweisseinheiten" [sort]="sort()" (sortChange)="sortChanged($event)">EE</th>
          <th class="!text-right min-w-[5rem]" softSortHeader="diff.eiweisseinheitenProz" [sort]="sort()" (sortChange)="sortChanged($event)">EE %</th>
        </tr>
        </thead>
        <tbody>
        @for (zeile of sortedDetails(); track $index) {
        <tr>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" [class.group]="zeile?.idkopfpr" class="md:!border-r min-w-[16rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">
            <div class="flex items-center gap-2">
              @if (zeile?.idkopfpr) {
              <div class="mr-1 cursor-pointer group-hover:text-primary" (click)="navigateToProduktionsauftrag(zeile)">
                <soft-icon [name]="'fa-regular fa-arrow-up-right-from-square fill-current text-inherit'" class="text-inherit"></soft-icon>
              </div>
              }
              <span class="group-hover:underline group-hover:text-primary" (click)="navigateToProduktionsauftrag(zeile)">{{ zeile?.artikel?.bezeichnung }}</span>
            </div>
          </td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="md:!border-r min-w-[16rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ zeile?.hfArtikel?.bezeichnung }}</td>
          <!-- -->
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.ist?.kg) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.ist?.liter) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.ist?.fetteinheiten) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ ((zeile?.ist?.fetteinheitenProz ?? 0) / 100) | percent:'1.2-2' }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.ist?.eiweisseinheiten) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="md:!border-r !text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ ((zeile?.ist?.eiweisseinheitenProz ?? 0) / 100) | percent:'1.2-2' }}</td>
          <!-- -->
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.soll?.kg) | number:'1.2-2' }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.soll?.liter) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.soll?.fetteinheiten) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ ((zeile?.soll?.fetteinheitenProz ?? 0) / 100) | percent:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.soll?.eiweisseinheiten) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="md:!border-r !text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ ((zeile?.soll?.eiweisseinheitenProz ?? 0) / 100) | percent:'1.2-2'  }}</td>
          <!-- -->
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.diff?.kg) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.diff?.liter) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.diff?.fetteinheiten) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ ((zeile?.diff?.fetteinheitenProz ?? 0) / 100) | percent:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ $safeNavigationMigration(zeile?.diff?.eiweisseinheiten) | number:'1.2-2'  }}</td>
          <td (dblclick)="navigateToProduktionsauftrag(zeile)" class="!text-right min-w-[5rem]" [ngClass]="zeile?.idkopfpr ? 'cursor-pointer' : 'cursor-default'">{{ ((zeile?.diff?.eiweisseinheitenProz ?? 0) / 100) | percent:'1.2-2' }}</td>
        </tr>
        }
        </tbody>
      </table>
    </div>
  } @else {
    <div class="text-center w-full soft-card !py-10 !px-8 flex items-center justify-center mt-4">
      @if (selectedRow() !== null) {
        <span class="text-sm font-normal italic text-light">Keine Daten für das Lagerymbol vorhanden</span>
      } @else {
          <span class="text-sm font-normal italic text-light">Bitte Lagersymbol auswählen um weitere Informationen einzusehen.</span>
      }
    </div>
  }
</soft-page>
